import { createElement, useState } from "react";
import { useSelectableLegalEntitiesByOwnership, useSelectableLegalEntityQuery } from "../../useSelectableLegalEntityQuery";
import { put } from "../../../common/api/apiShared";
import { ITransferLegalEntityDocumentDialogProps } from "./TransferLegalEntityDocumentDialog";
import { TransferLegalEntityDocument } from "./TransferLegalEntityDocumentDialog.types";
import { useValidator } from "../../../common/hooks/validation";
import { useTranslation } from "../../../localization/useTranslation";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export default function useTransferLegalEntityDocumentDialogHooks(props: ITransferLegalEntityDocumentDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    let legalEntitiesQuery = useSelectableLegalEntitiesByOwnership(props.isGroupEntity);

    const [saveModel, setSaveModel] = useState<TransferLegalEntityDocument>({
        documentId: props.documentId,
        toLegalEntityId: "",
        fromLegalEntity: legalEntitiesQuery.data?.find((x) => x.id === props.legalEntityId)?.name ?? "",
        toLegalEntity: "",
    });

    const validation = useValidator<TransferLegalEntityDocument>(
        (validators) => ({
            toLegalEntityId: validators.validateNotEmpty((item) => item.toLegalEntityId, translateString("legalEntity")),
        }),
        []
    );

    validation.check(saveModel);

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: (response: any) => {
            snackbar.show(
                createElement(Trans, {
                    i18nKey: "legalEntityDocumentTransferred",
                    values: {
                        from: saveModel.fromLegalEntity,
                        to: saveModel.toLegalEntity,
                    },
                })
            );
            props.onTransfered();
            props.onDialogClose();
        },
    });

    const transferDocument = async () => {
        if (validation.anyHasErrors) {
            validation.setShowErrors(true);
            return;
        }

        await saveMutation.mutateAsync();
    };

    function save() {
        return put<TransferLegalEntityDocument>(`/LegalEntity/${props.legalEntityId}/documents/transfer`, {
            toLegalEntityId: saveModel.toLegalEntityId,
            documentId: props.documentId,
        });
    }

    return {
        legalEntities: legalEntitiesQuery.data,
        isLoading: legalEntitiesQuery.isLoading,
        saveModel,
        setSaveModel,
        transferDocument,
        validation,
        isTransferring: saveMutation.isLoading,
    };
}
